import(/* webpackMode: "eager" */ "/workspace/src/app/(marketing)/page.tsx");
